import {
  Modal,
  Fade,
  Backdrop,
  Card,
  Icon,
  Tooltip,
  Slide,
  Grid,
  InputLabel,
  CircularProgress,
} from "@mui/material";
import PropTypes from "prop-types";
// Kaizen Dashboard components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import { MessageManager } from "context";
import { useCallback, useContext, useEffect, useState } from "react";
import { gql, useMutation } from "@apollo/client";
import { UserContext } from "context/user";
import SoftInput from "components/SoftInput";
import { validateDNI } from "utils/validations";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90%",
  width: { xs: "90%", sm: "75%", md: "70%", lg: "50%", xl: "30%" },
  py: 3,
  px: 3,
  overflow: "auto",
};

export default function ModalCompletarDatos({ open, handleClose, refetchParent }) {
  const { handleSnackbar } = useContext(MessageManager);
  const { user } = useContext(UserContext);
  const [data, setData] = useState({});
  const [saveUser, { loading }] = useMutation(gql`
    mutation saveUser($input: UserInput!) {
      saveUser(input: $input) {
        id
      }
    }
  `);

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  }, []);

  useEffect(() => {
    if (user) {
      setData({ telefono: user.telefono });
    }
  }, [user]);

  const handleSave = () => {
    const input = { ...data, id: user.id };
    saveUser({ variables: { input: input } })
      .then(() => {
        handleSnackbar("Datos actualizados correctamente", "success");
        refetchParent();
        handleClose();
      })
      .catch((error) => {
        handleSnackbar(error.message, "error");
      });
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox display="flex" justifyContent="space-between" alignItems="center">
            <SoftBox display="flex" alignItems="center" gap={1}>
              <SoftTypography variant="h5" fontWeight="bold">
                🚀
              </SoftTypography>
              <SoftTypography variant="h6" fontWeight="bold">
                Completa tus datos
              </SoftTypography>
            </SoftBox>
          </SoftBox>
          <SoftBox lineHeight={1}>
            <SoftTypography variant="caption" color="secondary" lineHeight={1}>
              Para poder continuar, requerimos que actualices tus datos personales.
            </SoftTypography>
          </SoftBox>
          <Grid container mt={1}>
            <Grid item xs={12} lg={6}>
              <InputLabel htmlFor="Telefono">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Numero de telefono
                </SoftTypography>
              </InputLabel>
              <SoftInput
                label="Telefono"
                placeholder="Telefono"
                type="text"
                name="telefono"
                error={data?.telefono?.length < 0 || data?.telefono?.length > 10}
                value={data?.telefono || ""}
                onChange={handleChange}
              />
            </Grid>
          </Grid>

          <SoftBox display="flex" justifyContent="flex-end" gap={1} mt={2}>
            <SoftButton
              variant="contained"
              color="primary"
              circular
              disabled={data?.telefono?.length < 0 || data?.telefono?.length > 10 || loading}
              onClick={handleSave}
            >
              {loading ? (
                <CircularProgress size={17} color="white" sx={{ mx: 5 }} />
              ) : (
                <div style={{ display: "flex", alignItems: "center" }}>
                  Actualizar{" "}
                  <SoftTypography variant="h6" my={-1}>
                    👌
                  </SoftTypography>
                </div>
              )}
            </SoftButton>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalCompletarDatos.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  refetchParent: PropTypes.func,
};
